import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OffcutTransition, OffcutItemDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface TransitionOffcutApiResponse {
  success: boolean;
  data: OffcutItemDto;
}

export function useTransitionOffcut() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }: { id: number; body: OffcutTransition }) => {
      const response = await apiClient.post<TransitionOffcutApiResponse>(
        `/offcuts/${id}/transition`,
        body,
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.offcuts.list() });
    },
  });
}
